import React from 'react';
import { useAppDispatch, useAppSelector } from 'core/store';

import { HTTPService } from 'core/services';
import useNotifiers from 'shared/Notifier/UseNotifiers';
import { notifierMessage } from '@dashboardWirelineDepartments/shared/constants';
import EngagementsMrcChart from '@dashboardWirelineDepartments/shared/EngagementsMrcChart';
import getEngagementsOrdersMrcAction from '@dashboardWirelineSellerDepartment/GetEngagementsOrdersMrc/actions';

const SellerEngagementsMrcChart = () => {
  const dispatch = useAppDispatch();
  const { showErrorNotifier } = useNotifiers();

  const engagementsMrc = useAppSelector((state) => state.dashboard.engagementsMrc.data);
  const isLoading = useAppSelector((state) => state.dashboard.engagementsMrc.isLoading);

  const getEngagementMrsData = async (newPeriod) => {
    try {
      const engagementsMrcController = HTTPService.getController();
      await dispatch(getEngagementsOrdersMrcAction(
        engagementsMrcController, newPeriod,
      ));
    } catch (e) {
      showErrorNotifier(notifierMessage.engagementsMrc.error, e);
    }
  };

  return (
    <EngagementsMrcChart
      list={engagementsMrc}
      isLoading={isLoading}
      onPeriodChange={getEngagementMrsData}
    />
  );
};

export default SellerEngagementsMrcChart;
